module.exports = __webpack_public_path__ + "images/winter-special-mobile-bg.jpg";